import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';


@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
})
export class LoginComponent {
  @HostBinding('class') cAppClass = 'c-app flex-row align-items-center';

  constructor(private auth: AuthService, private router: Router) {
  }

  ngOnInit(): void {

  }

  loginUser(event) {
    event.preventDefault();
    const target = event.target;
    const username = target.querySelector('#username').value;
    const password = target.querySelector('#password').value;

    this.auth.getUserDetails(username, password).subscribe(
      data => {
        this.auth.UserData = data;
        this.auth.loggedIn = true;
        this.auth.token = data.accessToken;
        //console.log(this.auth.UserData);
        this.router.navigate(['/cameras/grid']);
      },
      err => {
        if (err.error.error_message == "USER_NOT_FOUND" || err.error.error_message == "USER_WRONG_PASSWORD") {
          window.alert("Hibás felhasználónév vagy jelszó!")
        } else {
          window.alert("Ismeretlen hiba!")
        }
      });
  }
}
